FilesUploadModalController.$inject = ['$scope', 'stateService'];
function FilesUploadModalController(scope, stateService) {
  const ctrl = this;

  ctrl.$onInit = () => { }

  ctrl.ok = () => {
    scope.uploadFiles();
    ctrl.close({ $value: ctrl.type });
  };

  ctrl.cancel = () => {
    ctrl.dismiss();
  };

  scope.setFiles = function(element) {
    scope.$apply(function(scope) {
      console.log('files:', element.files);
      // Turn the FileList object into an Array
      scope.files = []
      for (let i = 0; i < element.files.length; i++) {
        scope.files.push(element.files[i])
      }
    // scope.progressVisible = false
    });
  };

  scope.uploadFiles = function() {
    for (let i in scope.files) {
      let id = scope.files[i].name.substring(1, scope.files[i].name.length - 4);
      let type = "";
      switch(scope.files[i].name.substring(0,1).toUpperCase()) {
        case 'B':
          type = "BEGIN";
          break;
        case 'M':
          type = "MIDDLE";
          break;
        case 'E':
          type = "END";
          break;
        default:
          type = "INDEPENDENT";
          break;    
      }
      stateService.uploadAudio(id, type, scope.files[i]).then(function(data) {
      });      
    }
  }
}

angular
  .module('segments.module')
  .controller('FilesUploadModalController', FilesUploadModalController);
